var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListNftSolid = function SvgListNftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.674 1.778C1 2.787 1 4.19 1 7v2c0 2.809 0 4.213.674 5.222.292.437.667.812 1.104 1.104C3.787 16 5.19 16 8 16c2.809 0 4.213 0 5.222-.674a4.003 4.003 0 0 0 1.104-1.104C15 13.213 15 11.81 15 9V7c0-2.809 0-4.213-.674-5.222A4.002 4.002 0 0 0 13.222.674C12.213 0 10.81 0 8 0 5.191 0 3.787 0 2.778.674a4 4 0 0 0-1.104 1.104Zm10.61 3.108a.817.817 0 0 0-.073-1.176.874.874 0 0 0-1.21.07L8.63 6.383l-.61-.724a.874.874 0 0 0-1.206-.118.818.818 0 0 0-.12 1.173L7.94 8.194c.159.19.395.301.646.306a.868.868 0 0 0 .658-.28l3.04-3.334Z",
    clipRule: "evenodd"
  })));
};
export default SvgListNftSolid;